import React from 'react'

const VideoPlayer = ({ videoUrl }) => (
  <div className="embed-responsive embed-responsive-16by9">
    <iframe title="flussonic-player" src={`${videoUrl}/embed.html`} />
  </div>
)
export default VideoPlayer



// WEBPACK FOOTER //
// ./src/components/VideoPlayer.js